import styled from 'styled-components';
import FastVehicleCreation from './FastVehicleCreation';
import { colorSchema } from 'utils/style';

export default styled(FastVehicleCreation)`
  .fast-vehicle-creation {
    display: flex;
    flex-direction: column;

    &__close {
      align-self: flex-end;
      background: none;
      border: 0;
      cursor: pointer;
      height: 24px;
      padding: 0;
      width: 24px;

      svg {
        fill: ${colorSchema('grey700')};
      }
    }

    &__title {
      color: ${colorSchema('grey900')};
      font-size: 2rem;
      font-weight: bold;
    }

    &__subtitle {
      color: ${colorSchema('grey700')};
      font-size: 1.6rem;
    }

    &__options {
      margin-bottom: 3rem;
    }

    &__options-title,
    &__extras-title {
      color: ${colorSchema('grey900')};
      font-size: 1.6rem;
      font-weight: 500;
    }

    &__plate {
      margin-bottom: 2.4rem;
    }

    &__plate-label {
      color: ${colorSchema('grey900')};
      display: flex;
      font-size: 1.6rem;
      font-weight: 500;
      margin-bottom: 0.4rem;
    }

    &__plate-input {
      height: 48px;
      margin-bottom: 0.4rem;
      width: 100%;
    }

    &__plate-error {
      color: ${colorSchema('error700')};
      font-size: 1.4rem;
    }

    &__action-button {
      width: 100%;
    }

    &__extras {
      display: flex;
      flex-direction: column;
      flex-wrap: wrap;
      margin-bottom: 3.2rem;
    }

    &__extra-item {
      margin-right: 1rem;
      width: calc(50% - 1rem);
    }
  }
`;
